module.exports = __webpack_public_path__ + "static/img/yeswecan0029.273c98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0029.png
// module id = 595
// module chunks = 1